import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import {
  Grid,
  makeStyles,
  Button,
  Box,
  Dialog,
  DialogContent,
  IconButton,
} from "@material-ui/core";
import { AiFillRead } from "react-icons/ai";
import { FaTimes } from "react-icons/fa";
import { Link, useHistory } from "react-router-dom";
import { backend } from "../../../api";
import { Skeleton } from "@material-ui/lab";
import CreateAdCard from "./CreateAdCard";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

const useStyles = makeStyles((theme) => ({
  Title: {
    fontSize: "36px",
    fontWeight: "600",
    marginTop: "0px",
  },
  input: {
    padding: 15,
    borderRadius: "2px",
  },
  priceTag: {
    margin: 0,
  },
  addBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    fontSize: "12px",
    height: "100%",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  toastBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    textDecoration: "none",
    marginLeft: "20px",
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  checkboxInput: {
    appearance: "none",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    border: `2px solid ${theme.palette.secondary.main}`,
    outline: "none",
    marginRight: theme.spacing(1),
    cursor: "pointer",
    position: "relative",
    transition: "border-color 0.2s ease-in-out",
    "&:checked": {
      borderColor: theme.palette.primary.main,
      "&::after": {
        content: '""',
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "10px",
        height: "10px",
        borderRadius: "50%",
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  checkboxLabel: {
    fontSize: "18px",
  },
  Description: {
    fontSize: "16px",
    lineHeight: 1.5,
    margin: "10px 0",
    whiteSpace: "pre-wrap",
  },
  quantityContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  quantityButton: {
    color: theme.palette.secondary.light,
    border: `1px solid ${theme.palette.primary.main}`,
    display: "flex",
    borderRadius: "5px",
    padding: "5px",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    transition: "background-color 0.3s, color 0.3s",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  quantityInput: {
    border: "none",
    padding: "8px",
    width: "50px",
    textAlign: "center",
  },
  authorSection: {
    marginTop: "20px",
  },
  bookCoverContainer: {
    position: "relative",
    width: "100%",
    maxWidth: "300px",
    height: "auto",
    margin: "0 auto",
    overflow: "hidden",
  },
  modalImage: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
  },
  modalContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    height: "100vh",
  },
  closeButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: theme.spacing(2),
    gap: theme.spacing(2),
  },
  content: {
    maxWidth: "700px",
    padding: theme.spacing(2),
  },
  imageContainer: {
    maxWidth: "300px",
    marginRight: theme.spacing(2),
    alignSelf: "flex-start",
  },
}));

function MainKleverBookDetail(props) {
  const { currentBook, wishlist, user, author, downloadedBooks } = props;
  const classes = useStyles();
  const logInUser = user.user
    ? user.user.role // customer
    : user.author
    ? user.author.role // author
    : user.role; // member
  const [bookOrder, setBookOrder] = useState({});
  const history = useHistory();
  const [favorite, setFavorite] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    handleFetchCurrentBookOrder();
  }, []);

  useEffect(() => {
    if (wishlist) {
      let favorite = wishlist.book.find(
        (book) => book._id === currentBook?._id
      );
      if (favorite) {
        setFavorite(true);
      } else {
        setFavorite(false);
      }
    }
  }, [wishlist]);

  const handleFetchCurrentBookOrder = () => {
    backend
      .get(`/bookOrder?book=${currentBook?._id}&user=${user._id}`)
      .then((res) => {
        setBookOrder(
          res.data.data.find((order) => order.book_price.digital_price)
        );
      })
      .catch((err) => {
        let message = err.response ? err.response.data.message : err.message;
      });
  };

  const handleReadBook = () => {
    const data = {
      user: user._id,
      book: currentBook?._id,
      adverbook: {
        ad_slots: currentBook?.ad_slots,
        book_category: currentBook?.book_category.map((category) => ({
          _id: category._id,
        })),
        book_title: currentBook?.book_title,
        price: currentBook?.price
      },
    };
    
    backend
      .post("/adverbook/download", data)
      .then((res) => {
        history.push("/dashboard/customer", { activeTab: 8 });
      })
      .catch((err) => {
        let message = err.response ? err.response.data.message : err.message;
        toast.error(`Error: ${message}`);
      });
  };

  const isBookDownloaded = downloadedBooks.some(
    (book) => book.book._id === currentBook._id && !book?.expired
  );

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <Box>
      <ToastContainer />
      {currentBook && author ? (
        <div className={classes.container}>
          <div className={classes.imageContainer}>
            <Zoom>
              <img
                src={currentBook?.book_cover}
                alt=""
                style={{ width: "100%", height: "auto", objectFit: "contain" }}
              />
            </Zoom>
          </div>
          <div className={classes.content}>
            <h1 className={classes.Title}>{currentBook?.book_title}</h1>
            <p className={classes.Description} style={{ textAlign: "justify" }}>{currentBook?.book_story}</p>
            {logInUser && logInUser === "member" ? (
              <CreateAdCard book={currentBook} member={user} />
            ) : logInUser && logInUser === "customer" ? (
              <Grid item xs={12} md={12}>
                <Button
                  className={classes.addBtn}
                  startIcon={<AiFillRead />}
                  fullWidth
                  onClick={handleReadBook}
                  disabled={isBookDownloaded}
                >
                  {isBookDownloaded ? "Book Read" : "Read Book"}
                </Button>
              </Grid>
            ) : null}
            {currentBook?.book_category &&
              currentBook?.book_category?.length > 0 && (
                <p>
                  <span
                    className={classes.Description}
                    style={{ fontWeight: "bold" }}
                  >
                    Categories:{" "}
                  </span>
                  {currentBook?.book_category?.map((category, index) => (
                    <span key={index}>
                      {category.category_name}
                      {index < currentBook.book_category.length - 1 ? ", " : ""}
                    </span>
                  ))}
                </p>
              )}
            <h1 className={`${classes.Title} ${classes.authorSection}`}>
              About the author
            </h1>
            <p
              className={`${classes.Description} ${classes.authorBiography}`}
              style={{ fontWeight: "bold" }}
            >
              {currentBook?.isAuthorAdmin
                ? currentBook?.authorDetail?.name
                : author?.name}
            </p>
            <p className={classes.authorBiography} style={{ textAlign: "justify" }}>
              {currentBook?.isAuthorAdmin
                ? currentBook?.authorDetail?.description
                : currentBook?.writer?.author_biography}
            </p>
          </div>
        </div>
      ) : (
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={5}>
              <Skeleton
                variant="rect"
                width="60%"
                height={450}
                style={{ margin: "0 auto" }}
                animation
              />
            </Grid>
            <Grid xs={12} sm={6} md={6} lg={7}>
              <Skeleton
                variant="rect"
                width="90%"
                height={100}
                animation="wave"
              />
              <Skeleton
                animation="wave"
                width="90%"
                style={{ marginTop: 40 }}
              />
              <Skeleton animation="wave" width="75%" />
              <Skeleton animation="wave" width="60%" />
              <Skeleton animation="wave" width="45%" />

              <Skeleton
                animation="wave"
                width={200}
                height={40}
                style={{ marginTop: 30 }}
              />
              <Skeleton animation="wave" width={200} height={40} />
              <Skeleton animation="wave" width={200} height={40} />

              <Box display="flex" mt={5}>
                <Skeleton
                  variant="rect"
                  width="40%"
                  height={40}
                  animation="wave"
                />
                <Skeleton
                  variant="rect"
                  width="40%"
                  height={40}
                  style={{ marginLeft: 20 }}
                  animation="wave"
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
      >
        <DialogContent className={classes.modalContent}>
          <IconButton
            className={classes.closeButton}
            onClick={handleCloseModal}
          >
            <FaTimes />
          </IconButton>
          <img
            src={currentBook?.book_cover}
            alt="Book Cover"
            className={classes.modalImage}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default MainKleverBookDetail;
